export const environment = {
  production: true,
  brand: 'PayBev',
  apiURL: 'https://paybevdevapi.azurewebsites.net/api/', //dev
  // apiURL: 'https://localhost:7105/api/', //local
  key: 'n4JOKJTDqfKFL4YU',
  iv: '3UgutxiCXNyx6YEE',
};

export const supplierPortalURL = {
  production: false,
  URL: 'https://supplier-dev.paybev.app/',  //dev
};

export const environmentURL = {
  //  define your api end point here
  apiURL: 'https://paybevdevapi.azurewebsites.net/', //dev
};
